export const formatAz = (digits) => {
  const d = digits.slice(0, 9);
  const parts = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9)].filter(Boolean);
  return parts.join(" ");
};

export const toDigits = (v) => {
  let d = (v || "").replace(/\D/g, "");
  if (d.length > 9 && d.startsWith("994")) d = d.slice(3);
  if (d.length > 9 && d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 9);
};

export const PhoneInput = ({ value, onChange, dark = false, testid, id, required }) => (
  <div className={`flex items-stretch rounded-xl overflow-hidden border ${dark ? "border-white/12 bg-[#1d1c1a] focus-within:border-[#D6AD62]" : "border-[#171715]/10 bg-white focus-within:border-[#D6AD62]"} transition-colors`}>
    <span className={`px-3 flex items-center text-[15px] font-semibold ${dark ? "text-[#D6AD62] border-r border-white/10" : "text-[#171715] border-r border-[#171715]/10"}`}>+994</span>
    <input
      id={id}
      data-testid={testid}
      type="tel"
      inputMode="numeric"
      autoComplete="tel-national"
      placeholder="50 123 45 67"
      required={required}
      value={formatAz(value)}
      onChange={(e) => onChange(toDigits(e.target.value))}
      className={`flex-1 min-w-0 bg-transparent px-3 py-3 outline-none text-[16px] ${dark ? "text-[#F3EEE4] placeholder:text-[#8b867c]" : ""}`}
    />
  </div>
);
